import React, { useState } from 'react';

import { useTranslation } from 'providers/GILT.provider';

const AutoMessagesHeader = ({ sortFunction, sortAutoSmsByMonth }) => {
  const { t } = useTranslation();

  const [isDateAsc, setIsDateAsc] = useState(true);
  const [isRecipientsAsc, setIsRecipientsAsc] = useState(true);
  const [isSmsCountsAsc, setIsSmsCountsAsc] = useState(true);
  const [isCostAsc, setIsCostAsc] = useState(true);

  // url communications/campaigns tab -> Automated Texts AutoMessagesHeader
  return (
    <div data-bem="AutoMessagesHeader" className="sticky-navbar-automsg">
      <table className="tbl-automsg-sort">
        <tbody>
          <tr>
            <td className="date-width">
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  sortFunction('dateSent', isDateAsc);
                  setIsDateAsc((prev) => !prev);
                }}
                className="sort-btn"
              >
                {t('campaigns.tableHeaders.dateSent')}
              </span>
            </td>

            <td className="target-width">
              <span className="sort-btn no-arrow">{t('campaigns.tableHeaders.audience')}</span>
            </td>

            <td className="message-width">
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  sortAutoSmsByMonth('recipients', isRecipientsAsc);
                  setIsRecipientsAsc((prev) => !prev);
                }}
                className="sort-btn"
              >
                {t('campaigns.tableHeaders.recipients')}
              </span>
            </td>

            <td className="sms-sent-width">
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  sortAutoSmsByMonth('smsCount', isSmsCountsAsc);
                  setIsSmsCountsAsc((prev) => !prev);
                }}
                className="sort-btn"
              >
                {t('campaigns.tableHeaders.sentTexts')}
              </span>
            </td>

            <td className="booking-width">
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  sortAutoSmsByMonth('bookingReceived', isSmsCountsAsc);
                  setIsSmsCountsAsc((prev) => !prev);
                }}
                className="sort-btn"
              >
                {t('campaigns.tableHeaders.bookings')}
              </span>
            </td>

            <td className="revenue-width">
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  sortAutoSmsByMonth('revenue', isSmsCountsAsc);
                  setIsSmsCountsAsc((prev) => !prev);
                }}
                className="sort-btn"
              >
                {t('campaigns.tableHeaders.revenue')}
              </span>
            </td>

            <td className="sms-cost-width">
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  sortAutoSmsByMonth('smsCost', isCostAsc);
                  setIsCostAsc((prev) => !prev);
                }}
                className="sort-btn"
              >
                {t('campaigns.tableHeaders.textsCost')}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default AutoMessagesHeader;
